import { useAppSelector } from "../services/storeProvider"
import { isUser } from "../utilities"

const useIsUser = () => {
    const role = useAppSelector((state) => state.user.loggedUser.roles)

    return isUser(role)
}

export default useIsUser